import { DimensionValue } from 'react-native';
import useCustomTheme from '../hooks/theme-hook';
import { StylesHelper } from '../models/helpers/stylesHelper';
import { Platform } from 'react-native';

const useMissionCardStyles = () => {
  const theme = useCustomTheme();
  const isDarkMode = !!theme.isDark;

  let mapControl = {
    containerBase: {
      ...StylesHelper.padding(12),
      borderBottomWidth: 1,
      borderColor: theme.borderColorLight,
      flexGrow: 0,
      width: '100%' as DimensionValue,
    },
    container: {
      listItem: {
        minHeight: 96,
      },
      drawer: {
        backgroundColor: theme.background.modal,
        borderBottomWidth: 0,
      },
      card: {
        borderWidth: 1,
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: '48%',
        maxWidth: 400,
        minWidth: 320,
        ...StylesHelper.margin(0, 4, 8, 4),
      },
      selected: {
        borderColor: theme.secondaryLight,
      },
      pinned: {
        backgroundColor: theme.background.missionCard,
        borderColor: theme.background.primaryLight,
      },
      flashColor: {
        backgroundColor: theme.missionCard?.flashBackgroundLight ?? '#f7f0e2',
        borderColor: isDarkMode ? '#6F8595' : '#d8d2c7',
      },
    },
    cardBase: {
      display: 'flex' as any,
      flexDirection: 'row' as any,
      alignItems: 'center' as any,
    },
    header: {
      logoBase: {
        display: 'flex' as any,
        flexDirection: 'row' as any,
        alignItems: 'center' as any,
        justifyContent: 'center' as any,
        height: 48,
        width: 48,
        flexShrink: 0,
        marginRight: 12,
        borderRadius: 24,
        borderWidth: 1,
        borderColor: theme.borderColorLight,
        overflow: 'hidden' as any,
        backgroundColor: theme.background.secondary,
      },
      logo: {
        image: {
          width: '100%' as DimensionValue,
          height: '100%' as DimensionValue,
        },
        icon: {
          padding: 12,
          color: isDarkMode ? '#ffffff' : theme.text.titleLight.toString(),
          width: '100%' as DimensionValue,
          height: '100%' as DimensionValue,
        },
      },
    },
    info: {
      flexGrow: 1,
      flexShrink: 1,
      minWidth: 0,
      marginRight: 8,
    },
    missionName: {
      flexDirection: 'row' as any,
      alignItems: 'flex-start' as any,
      gap: 8,
      flexGrow: 1,
      flexShrink: 1,
    },
    missionIcons: {
      flexShrink: 0,
      gap: 8,
      justifyContent: 'flex-end' as any,
      flexDirection: 'row' as any,
      alignItems: 'center' as any,
    },
    missionHiddenIcon: {
      marginLeft: 4,
      color: theme.borderColor as any,
    },
    competitorCircuitBadge: {
      alignSelf: 'flex-start' as any,
      alignItems: 'center' as any,
      flexDirection: 'row' as any,
      gap: 4,
      paddingHorizontal: 7,
      paddingVertical: 3,
      marginTop: 3,
      marginBottom: 3,
      borderRadius: 12,
      borderWidth: 1,
      borderColor: theme.secondaryLight,
    },
    competitorCircuitBadgeLabel: {
      color: theme.secondaryLight,
      fontSize: 10,
      fontWeight: '700' as any,
    },
    flashMissionIcon: {
      width: 8,
      height: 14,
      alignSelf: 'flex-end' as any,
    },
    preTitle: {
      flexDirection: 'row' as any,
      gap: 8,
      justifyContent: 'space-between' as any,
      flexShrink: 1,
    },
  };

  return mapControl as typeof mapControl;
};

export default useMissionCardStyles;
